

// import React, { useEffect, useRef, useState } from "react";
// import {
//     AppBar,
//     Toolbar,
//     List,
//     ListItem,
//     ListItemButton,
//     ListItemText,
//     Box,
//     Drawer,
//     IconButton,
//     Grid,
//     Collapse,
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
// import "./CustomAppBar.css";
// import logo from "../../Assets/WeConnectLogo.png";
// import { IoHomeOutline } from "react-icons/io5";
// import { GrTableAdd } from "react-icons/gr";
// import { FiFilePlus } from "react-icons/fi";
// // import { FcAbout } from "react-icons/fc";
// import { RiFolderInfoFill } from "react-icons/ri";

// // import React, { useState } from "react";
// import { Menu, MenuItem, Avatar, Typography } from "@mui/material";
// import { AccountCircle, ExpandLess, ExpandMore } from "@mui/icons-material";
// import profileImageIcon from "../../Assets/user_man_image.png"
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import { MdNotificationsNone } from "react-icons/md";
// import { LuMessageSquareText } from "react-icons/lu";
// import { MdOutlineWorkOutline } from "react-icons/md";
// import { FaUserSecret } from "react-icons/fa6";
// import { TbUsersGroup } from "react-icons/tb";
// import { useDispatch, useSelector } from 'react-redux'
// import actions from "../../ReduxStore/actions";
// import { adminUrl } from "../../constants";



// const CustomUserAppBar = () => {
//     const [drawerOpen, setDrawerOpen] = useState(false);
//     const location = useLocation()
//     const dispatch = useDispatch()
//     const sessionUserId = sessionStorage.getItem("userId")

//     const { getUserById } = useSelector(state => state?.getUserById);
//     const { editUserInfo } = useSelector(state => state?.editUserInfo);



//     // const sessionUserId = sessionStorage.getItem("userId")

//     // const dispatch = useDispatch()
//     useEffect(() => {

//         const fetchData = async () => {
//             const data1 = {
//                 data: {},
//                 method: "get",
//                 apiName: `getUserById/${sessionUserId}`,
//             };
//             const response = await dispatch(actions.GETUSERBYID(data1));


//         }
//         fetchData()


//     }, [editUserInfo])

//     const { getNotificationCategoryCounts } = useSelector(state => state?.getNotificationCategoryCounts);

//     console.log(getNotificationCategoryCounts, 'getNotificationCategoryCounts');


//     const navItems = [
//         {
//             label: "Home", path: "/user", icon: IoHomeOutline
//         },
//         {
//             label: "Connect-Friends", path: "/user/connectfriends", icon: TbUsersGroup
//         },
//         {
//             label: "Notifications", path: "/user/notification", icon: MdNotificationsNone
//         }, {
//             label: "Messages", path: "/user/messages", icon: LuMessageSquareText
//         },
//         {
//             label: "Post", subLabel: [
//                 {
//                     icon: IoHomeOutline,
//                     sublabel: "Post Jobs",
//                     subPath: "/user/postjobs"
//                 },
//                 {
//                     icon: IoHomeOutline,
//                     sublabel: "Post Internship",
//                     subPath: "/user/postinternship"
//                 },
//                 // {
//                 //     icon: IoHomeOutline,
//                 //     sublabel: "Search Jobs",
//                 //     subPath: "/user/searchjob"
//                 // },
//                 // {
//                 //     icon: IoHomeOutline,
//                 //     sublabel: "Serach Internship",
//                 //     subPath: "/user/searchinternship"
//                 // },
//                 // {
//                 //     icon: IoHomeOutline,
//                 //     sublabel: "Upload Resume",
//                 //     subPath: "/user/uploadresume"
//                 // }
//             ], path: "/user/post", icon: MdOutlineWorkOutline
//         },
//         // {
//         //     label: "Reports", subLabel: [
//         //         {
//         //             icon: IoHomeOutline,
//         //             sublabel: "Alumni Registration-Confirmation",
//         //             subPath: "/alumni_register_confirmation"
//         //         },
//         //         {
//         //             icon: IoHomeOutline,
//         //             sublabel: "Alumni Report-Search By Course",
//         //             subPath: "/reportsearch_course"
//         //         },
//         //         {
//         //             icon: IoHomeOutline,
//         //             sublabel: "Alumni Report-Search By Name",
//         //             subPath: "/reportsearch_name"
//         //         }
//         //     ], path: "/reports", icon: FiFilePlus
//         // },
//         {
//             label: "About-us", path: "/user/aboutus", icon: RiFolderInfoFill
//         },

//     ];

//     const toggleDrawer = (open) => (event) => {
//         if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
//             return;
//         }
//         setDrawerOpen(open);
//     };
//     const [anchorEl, setAnchorEl] = useState(null);
//     const [submenuOpen, setSubmenuOpen] = useState(null);
//     const [anchorElMain, setAnchorElMain] = useState(null); // For main menu
//     const [anchorElSub, setAnchorElSub] = useState(null); // For submenu
//     // const { getUserById } = useSelector(state => state?.getUserById);


//     const handleSubMenuOpen = (event, label) => {
//         setAnchorElSub(event.currentTarget); // Use a separate state for submenu anchor
//         setSubmenuOpen(label);


//     };

//     const handleSubMenuClose = () => {
//         setAnchorElSub(null);
//         setSubmenuOpen(null);
//         console.log("onnnnnn");
//     };


//     const handleMenuOpen = (event) => {
//         setAnchorEl(event.currentTarget);
//     };

//     const handleMenuClose = () => {
//         setAnchorEl(null);
//     };

//     const navigate = useNavigate()

//     const { markRoomNotificationsAsRead } = useSelector(
//         (state) => state?.markRoomNotificationsAsRead
//     );

//     useEffect(() => {

//         console.log("responseresponse out");

//         const fetchData = async () => {
//             const data1 = {
//                 data: {},
//                 method: "get",
//                 apiName: `getNotificationCategoryCounts/${sessionUserId}`,
//             };
//             const response = await dispatch(actions.GETNOTIFICATIONCATEGORYCOUNTS(data1));


//         }
//         fetchData()
//     }, [markRoomNotificationsAsRead])



//     const handleNotificationApiCL = async () => {
//         const data1 = {
//             data: {},
//             method: "get",
//             apiName: `getNotificationCategoryCounts/${sessionUserId}`,
//         };
//         const response = await dispatch(actions.GETNOTIFICATIONCATEGORYCOUNTS(data1));

//     }



//     const handleNavigation = (path) => {
//         console.log(`Navigating to ${path}`);
//         navigate(path)
//     };

//     const handleNavigationLogout = () => {
//         console.log("Logging out...");
//     };

//     const sessionFirstName = "John"; // Replace with actual session data
//     const sessioncustomer_id = 12345; // Replace with actual session data
//     // const profileImageIcon=""



//     return (
//         <>
//             {/* Custom Navbar */}
//             {/* <AppBar
//         // position="fixed"
//         sx={{
//           background: "#fff",
//           boxShadow: "4px 8px 25px rgba(0, 0, 0, 0.1)",
//           borderRadius: "50px",
//           padding: "10px 20px",
//           margin: "10px auto",
//           // maxWidth: "85%",
//           display: "flex",
//           alignItems: "center",
//         }}
//       > */}
//             <AppBar
//                 position="static"  // Keeps AppBar at the top but allows smooth scrolling behavior
//                 sx={{
//                     background: "var(--main-color)",
//                     boxShadow: "4px 8px 25px rgba(0, 0, 0, 0.1)",
//                     // borderRadius: "50px",
//                     padding: "10px 20px",
//                     // margin: "10px auto",
//                     // maxWidth: "85%",
//                     // display: "flex",
//                     // alignItems: "center",
//                     // top: 0,  // Ensures it sticks at the top
//                     zIndex: 1100,  // Keeps it above other content
//                 }}
//             >

//                 <Box className="appbar-container" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
//                     {/* Logo */}
//                     <Box className="nav-logo">
//                         <Box component="img" src={logo} alt="Logo" className="nav-logo-img" sx={{ height: { xs: "40px", md: "50px" }, width: { xs: "110px", md: "200px" } }} />
//                     </Box>

//                     {/* Navigation Menu for Desktop */}

//                     <Toolbar sx={{ flexGrow: 1, justifyContent: "end", display: { xs: "none", md: "flex" } }}>
//                         <Grid container className="nav-menu" spacing={2} justifyContent="center">
//                             {navItems.map((item) => (

//                                 <Grid item key={item.label}>
//                                     <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}>

//                                         <ListItemButton
//                                             component={Link}
//                                             to={item.path || "#"}
//                                             sx={{
//                                                 position: "relative",
//                                                 // color: "white",
//                                                 // color: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "red" : "black",

//                                                 borderRadius: "10px",
//                                                 // transition: "0.3s",
//                                                 // "&::after": {
//                                                 //     content: '""',
//                                                 //     position: "absolute",
//                                                 //     // color: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "red" : "black",
//                                                 //     // left: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "23%" : "50%",
//                                                 //     bottom: 0,
//                                                 //     // width: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "60%" : "0%",
//                                                 //     height: "3px",
//                                                 //     // borderRadius: "10px",
//                                                 //     backgroundColor: "white",
//                                                 //     transition: "width 0.3s ease, left 0.3s ease",
//                                                 // },
//                                                 // "&:hover::after": {
//                                                 //     color: "red"
//                                                 //     // width: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "60%" : "60%",
//                                                 //     // left: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "20%" : "20%",
//                                                 // },
//                                             }}
//                                             onClick={(e) => {
//                                                 handleNotificationApiCL()
//                                                 if (item.subLabel) {
//                                                     e.preventDefault();
//                                                     handleSubMenuOpen(e, item.label)

//                                                     setSubmenuOpen(submenuOpen === item.label ? null : item.label);
//                                                 } else {
//                                                     setSubmenuOpen(null);
//                                                 }
//                                             }}
//                                         >
//                                             <div style={{ position: "relative", display: "inline-block" }}>
//                                                 <item.icon style={{
//                                                     color: "white",
//                                                     // marginRight: "5px",
//                                                     fontSize: "20px",
//                                                     // color: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "white" : "white",

//                                                 }}
//                                                 />
//                                                 {"Messages" === item.label || "Notifications" === item.label ? (
//                                                     <span
//                                                         style={{
//                                                             position: "absolute",
//                                                             top: "-5px",
//                                                             right: "-5px",
//                                                             backgroundColor: "red",
//                                                             color: "white",
//                                                             borderRadius: "50%",
//                                                             padding: "2px 6px",
//                                                             fontSize: "12px",
//                                                             fontWeight: "bold",
//                                                             lineHeight: 1,
//                                                         }}
//                                                     >
//                                                         {"Messages" === item.label && getNotificationCategoryCounts?.data[3]?.count}
//                                                         {"Notifications" === item.label && getNotificationCategoryCounts?.data[0]?.count}
//                                                     </span>) : ""}

//                                             </div>
//                                             {/* {item.label || "Default Label"} */}
//                                             {/* {item.subLabel && <ExpandMoreIcon sx={{ color: "white" }} />} */}
//                                         </ListItemButton>




//                                     </Box>

//                                     {submenuOpen === item.label && (

//                                         <Menu
//                                             anchorEl={anchorElSub}
//                                             open={Boolean(anchorElSub)}
//                                             onClose={handleSubMenuClose}
//                                             sx={{ mt: 1 }}
//                                         >
//                                             {item.subLabel.map((sub) => (
//                                                 <MenuItem key={sub.subPath} component={Link} to={sub.subPath}>
//                                                     <Typography variant="subtitle1" sx={{ color: "black" }}>
//                                                         {sub.sublabel}

//                                                     </Typography>

//                                                 </MenuItem>
//                                             ))}
//                                         </Menu>
//                                     )}

//                                 </Grid>
//                             ))}
//                         </Grid>

//                     </Toolbar>

//                     <IconButton
//                         edge="end"
//                         sx={{
//                             display: { xs: "block", md: "none" },
//                             // background: "#f5f5f5",
//                             // padding: "8px",
//                             // borderRadius: "50%",
//                         }}
//                         onClick={toggleDrawer(true)}
//                     >
//                         <MenuIcon sx={{ color: "#252525", fontSize: "28px" }} />
//                     </IconButton>
//                     <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                         {/* <AccountCircleIcon /> */}
//                         <Box
//                             sx={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 cursor: 'pointer',
//                             }}
//                             onClick={handleMenuOpen}
//                         >
//                             {getUserById?.data?.profileImage ? (
//                                 <Avatar
//                                     src={`${adminUrl}${getUserById?.data?.profileImage}`}
//                                     alt="John Doe"
//                                     sx={{
//                                         width: { md: 40, xs: 30 },
//                                         height: { md: 40, xs: 30 },
//                                         border: "4px solid white",
//                                         // marginTop: "-80px",
//                                         // marginLeft: "50px"
//                                     }}
//                                 />
//                             ) : (
//                                 <Box
//                                     sx={{
//                                         border: '1px solid black',
//                                         borderRadius: '50%',
//                                         background: 'black',
//                                         display: 'flex',
//                                         justifyContent: 'center',
//                                         alignItems: 'center',
//                                         // height: { xs: "20px", md: '35px' },
//                                         // width: { xs: "20px", md: '35px' },

//                                         p: { xs: "5px", md: '10px' }

//                                     }}
//                                 >


//                                     <Box
//                                         component="img"
//                                         src={profileImageIcon}
//                                         alt="profile-icon"
//                                         sx={{
//                                             height: { xs: "14px", md: '16px' },
//                                             width: { xs: "14px", md: '16px' },
//                                         }}
//                                     />
//                                 </Box>
//                             )}
//                             <Box sx={{ paddingLeft: { xs: '5px', md: "10px" } }}>
//                                 <Typography variant="body1" sx={{ fontSize: { xs: '12px', md: "14px", color: "white" } }}>
//                                     My Account
//                                 </Typography>

//                                 <Typography variant="body1" sx={{ fontSize: { xs: '10px', md: "12px" }, color: "white" }}>
//                                     {getUserById?.data?.first_name} {getUserById?.data?.last_name}
//                                 </Typography>
//                             </Box>
//                         </Box>


//                         <Menu
//                             anchorEl={anchorEl}
//                             open={Boolean(anchorEl)}
//                             onClose={handleMenuClose}
//                             sx={{ mt: 1 }}
//                         >
//                             {sessioncustomer_id === "null" || sessioncustomer_id === null ? (
//                                 // If sessionCustomerId is null or "null", show login and register options
//                                 <>
//                                     <MenuItem onClick={() => handleNavigation('/login')}>Login</MenuItem>
//                                     <MenuItem onClick={() => handleNavigation('/register')}>Register</MenuItem>
//                                 </>
//                             ) : (
//                                 // If sessionCustomerId is not null, show order history, profile, and logout options
//                                 <>
//                                     <MenuItem onClick={() => handleNavigation('/user/editprofile')}>Edit Profile</MenuItem>

//                                     <MenuItem onClick={() => handleNavigation('/changepassword')}>Change Password</MenuItem>

//                                     <MenuItem onClick={() => handleNavigation('/')}>Logout</MenuItem>

//                                 </>
//                             )}
//                         </Menu>


//                     </Box>

//                     {/* Mobile Menu Icon */}

//                 </Box>
//             </AppBar >


//             <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
//                 <Box sx={{ width: 250, background: "#fff", padding: "20px", height: "100%" }}>
//                     <List>
//                         {navItems.map((item) => (
//                             <Box key={item.label}>
//                                 <ListItemButton
//                                     component={Link}
//                                     to={item.path}
//                                     sx={{

//                                         color: location.pathname === item.path ? "white" : "#252525",
//                                         fontWeight: location.pathname === item.path ? "bold" : "normal",
//                                         background: location.pathname === item.path ? "var(--main-color)" : "transparent",
//                                         borderRadius: "10px",
//                                         transition: "0.3s",
//                                         "&:hover": {
//                                             background: "#f5f5f5",
//                                         },
//                                     }}
//                                     // onClick={() => setSubmenuOpen(submenuOpen === item.label ? null : item.label)}
//                                     onClick={(e) => {
//                                         // e.preventDefault(); // Prevents navigation if needed
//                                         console.log("this");

//                                         if (item.subLabel) {
//                                             e.preventDefault();
//                                             setSubmenuOpen(submenuOpen === item.label ? null : item.label);
//                                         } else {
//                                             setSubmenuOpen(null); // Handle cases where label is missing
//                                         }
//                                     }}
//                                 >
//                                     <item.icon style={{ color: "white", marginRight: "5px" }} />
//                                     {item.label}
//                                     {item.subLabel && (submenuOpen === item.label ? <ExpandLess /> : <ExpandMore />)}
//                                 </ListItemButton>

//                                 {/* Submenu */}
//                                 {item.subLabel && (
//                                     <Collapse in={submenuOpen === item.label} timeout="auto" unmountOnExit>
//                                         <List component="div" disablePadding>
//                                             {item.subLabel.map((sub) => (
//                                                 <ListItemButton key={sub.subPath} component={Link} to={sub.subPath} sx={{ pl: 4 }}>
//                                                     <ListItemText primary={sub.sublabel} />
//                                                 </ListItemButton>
//                                             ))}
//                                         </List>
//                                     </Collapse>
//                                 )}
//                             </Box>
//                         ))}
//                     </List>
//                 </Box>
//             </Drawer>
//         </>
//     );
// };

// export default CustomUserAppBar;




// ---------------------------------------------------------------------



// import React, { useEffect, useRef, useState } from "react";
// import {
//     AppBar,
//     Toolbar,
//     List,
//     ListItem,
//     ListItemButton,
//     ListItemText,
//     Box,
//     Drawer,
//     IconButton,
//     Grid,
//     Collapse,
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
// import "./CustomAppBar.css";
// import logo from "../../Assets/WeConnectLogo.png";
// import { IoHomeOutline } from "react-icons/io5";
// import { GrTableAdd } from "react-icons/gr";
// import { FiFilePlus } from "react-icons/fi";
// // import { FcAbout } from "react-icons/fc";
// import { RiFolderInfoFill } from "react-icons/ri";

// // import React, { useState } from "react";
// import { Menu, MenuItem, Avatar, Typography } from "@mui/material";
// import { AccountCircle, ExpandLess, ExpandMore } from "@mui/icons-material";
// import profileImageIcon from "../../Assets/user_man_image.png"
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import { MdNotificationsNone } from "react-icons/md";
// import { LuMessageSquareText } from "react-icons/lu";
// import { MdOutlineWorkOutline } from "react-icons/md";
// import { FaUserSecret } from "react-icons/fa6";
// import { TbUsersGroup } from "react-icons/tb";
// import { useSelector } from "react-redux";


// const CustomUserAppBar = () => {
//     const [drawerOpen, setDrawerOpen] = useState(false);
//     const location = useLocation();

//     const navItems = [
//         {
//             label: "Home", path: "/user", icon: IoHomeOutline
//         },
//         {
//             label: "Connect-Friends", path: "/user/connectfriends", icon: TbUsersGroup
//         },
//         {
//             label: "Notifications", path: "/user/notification", icon: MdNotificationsNone
//         }, {
//             label: "Messages", path: "/user/messages", icon: LuMessageSquareText
//         },
//         {
//             label: "Post", subLabel: [
//                 {
//                     icon: IoHomeOutline,
//                     sublabel: "Post Jobs",
//                     subPath: "/user/postjobs"
//                 },
//                 {
//                     icon: IoHomeOutline,
//                     sublabel: "Post Internship",
//                     subPath: "/user/postinternship"
//                 },
//                 {
//                     icon: IoHomeOutline,
//                     sublabel: "Search Jobs",
//                     subPath: "/user/searchjob"
//                 },
//                 {
//                     icon: IoHomeOutline,
//                     sublabel: "Serach Internship",
//                     subPath: "/user/searchinternship"
//                 },
//                 {
//                     icon: IoHomeOutline,
//                     sublabel: "Upload Resume",
//                     subPath: "/user/uploadresume"
//                 }
//             ], path: "/user/post", icon: MdOutlineWorkOutline
//         },
//         // {
//         //     label: "Reports", subLabel: [
//         //         {
//         //             icon: IoHomeOutline,
//         //             sublabel: "Alumni Registration-Confirmation",
//         //             subPath: "/alumni_register_confirmation"
//         //         },
//         //         {
//         //             icon: IoHomeOutline,
//         //             sublabel: "Alumni Report-Search By Course",
//         //             subPath: "/reportsearch_course"
//         //         },
//         //         {
//         //             icon: IoHomeOutline,
//         //             sublabel: "Alumni Report-Search By Name",
//         //             subPath: "/reportsearch_name"
//         //         }
//         //     ], path: "/reports", icon: FiFilePlus
//         // },
//         {
//             label: "About-us", path: "/user/aboutus", icon: RiFolderInfoFill
//         },

//     ];

//     const toggleDrawer = (open) => (event) => {
//         if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
//             return;
//         }
//         setDrawerOpen(open);
//     };
//     const [anchorEl, setAnchorEl] = useState(null);
//     const [submenuOpen, setSubmenuOpen] = useState(null);
//     const [anchorElMain, setAnchorElMain] = useState(null); // For main menu
//     const [anchorElSub, setAnchorElSub] = useState(null); // For submenu
//     const { getUserById } = useSelector(state => state?.getUserById);


//     const handleSubMenuOpen = (event, label) => {
//         setAnchorElSub(event.currentTarget); // Use a separate state for submenu anchor
//         setSubmenuOpen(label);
//     };

//     const handleSubMenuClose = () => {
//         setAnchorElSub(null);
//         setSubmenuOpen(null);
//     };


//     const handleMenuOpen = (event) => {
//         setAnchorEl(event.currentTarget);
//     };

//     const handleMenuClose = () => {
//         setAnchorEl(null);
//     };

//     const navigate = useNavigate()
//     const handleNavigation = (path) => {
//         console.log(`Navigating to ${path}`);
//         navigate(path)
//     };

//     const handleNavigationLogout = () => {
//         console.log("Logging out...");
//     };

//     const sessionFirstName = "John"; // Replace with actual session data
//     const sessioncustomer_id = 12345; // Replace with actual session data
//     // const profileImageIcon=""



//     return (
//         <>
//             {/* Custom Navbar */}
//             {/* <AppBar
//         // position="fixed"
//         sx={{
//           background: "#fff",
//           boxShadow: "4px 8px 25px rgba(0, 0, 0, 0.1)",
//           borderRadius: "50px",
//           padding: "10px 20px",
//           margin: "10px auto",
//           // maxWidth: "85%",
//           display: "flex",
//           alignItems: "center",
//         }}
//       > */}
//             <AppBar
//                 position="static"  // Keeps AppBar at the top but allows smooth scrolling behavior
//                 sx={{
//                     background: "var(--main-color)",
//                     boxShadow: "4px 8px 25px rgba(0, 0, 0, 0.1)",
//                     // borderRadius: "50px",
//                     padding: "10px 20px",
//                     // margin: "10px auto",
//                     // maxWidth: "85%",
//                     // display: "flex",
//                     // alignItems: "center",
//                     // top: 0,  // Ensures it sticks at the top
//                     zIndex: 1100,  // Keeps it above other content
//                 }}
//             >

//                 <Box className="appbar-container" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
//                     {/* Logo */}
//                     <Box className="nav-logo">
//                         <Box component="img" src={logo} alt="Logo" className="nav-logo-img" sx={{ height: { xs: "40px", md: "50px" }, width: { xs: "110px", md: "200px" } }} />
//                     </Box>

//                     {/* Navigation Menu for Desktop */}

//                     <Toolbar sx={{ flexGrow: 1, justifyContent: "end", display: { xs: "none", md: "flex" } }}>
//                         <Grid container className="nav-menu" spacing={2} justifyContent="center">
//                             {navItems.map((item) => (

//                                 <Grid item key={item.label}>
//                                     <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}>

//                                         <ListItemButton
//                                             component={Link}
//                                             to={item.path || "#"}
//                                             sx={{
//                                                 position: "relative",
//                                                 // color: "white",
//                                                 // color: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "red" : "black",

//                                                 borderRadius: "10px",
//                                                 // transition: "0.3s",
//                                                 // "&::after": {
//                                                 //     content: '""',
//                                                 //     position: "absolute",
//                                                 //     // color: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "red" : "black",
//                                                 //     // left: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "23%" : "50%",
//                                                 //     bottom: 0,
//                                                 //     // width: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "60%" : "0%",
//                                                 //     height: "3px",
//                                                 //     // borderRadius: "10px",
//                                                 //     backgroundColor: "white",
//                                                 //     transition: "width 0.3s ease, left 0.3s ease",
//                                                 // },
//                                                 // "&:hover::after": {
//                                                 //     color: "red"
//                                                 //     // width: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "60%" : "60%",
//                                                 //     // left: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "20%" : "20%",
//                                                 // },
//                                             }}
//                                             onClick={(e) => {
//                                                 if (item.subLabel) {
//                                                     e.preventDefault();
//                                                     handleSubMenuOpen(e, item.label)

//                                                     setSubmenuOpen(submenuOpen === item.label ? null : item.label);
//                                                 } else {
//                                                     setSubmenuOpen(null);
//                                                 }
//                                             }}
//                                         >
//                                             <item.icon style={{
//                                                 color: "white",
//                                                 // marginRight: "5px",
//                                                 fontSize: "20px",
//                                                 // color: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "white" : "white",

//                                             }}
//                                             />
//                                             {/* {item.label || "Default Label"} */}
//                                             {/* {item.subLabel && <ExpandMoreIcon sx={{ color: "white" }} />} */}
//                                         </ListItemButton>




//                                     </Box>

//                                     {submenuOpen === item.label && (

//                                         <Menu
//                                             anchorEl={anchorElSub}
//                                             open={Boolean(anchorElSub)}
//                                             onClose={handleSubMenuClose}
//                                             sx={{ mt: 1 }}
//                                         >
//                                             {item.subLabel.map((sub) => (
//                                                 <MenuItem key={sub.subPath} component={Link} to={sub.subPath}>
//                                                     <Typography variant="subtitle1" sx={{ color: "black" }}>
//                                                         {sub.sublabel}

//                                                     </Typography>

//                                                 </MenuItem>
//                                             ))}
//                                         </Menu>
//                                     )}

//                                 </Grid>
//                             ))}
//                         </Grid>

//                     </Toolbar>

//                     <IconButton
//                         edge="end"
//                         sx={{
//                             display: { xs: "block", md: "none" },
//                             // background: "#f5f5f5",
//                             // padding: "8px",
//                             // borderRadius: "50%",
//                         }}
//                         onClick={toggleDrawer(true)}
//                     >
//                         <MenuIcon sx={{ color: "#252525", fontSize: "28px" }} />
//                     </IconButton>
//                     <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                         {/* <AccountCircleIcon /> */}
//                         <Box
//                             sx={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 cursor: 'pointer',
//                             }}
//                             onClick={handleMenuOpen}
//                         >
//                             {profileImageIcon ? (
//                                 <Avatar
//                                     src={`${profileImageIcon}`}
//                                     alt="John Doe"
//                                     sx={{
//                                         width: { md: 40, xs: 30 },
//                                         height: { md: 40, xs: 30 },
//                                         border: "4px solid white",
//                                         // marginTop: "-80px",
//                                         // marginLeft: "50px"
//                                     }}
//                                 />
//                             ) : (
//                                 <Box
//                                     sx={{
//                                         border: '1px solid black',
//                                         borderRadius: '50%',
//                                         background: 'black',
//                                         display: 'flex',
//                                         justifyContent: 'center',
//                                         alignItems: 'center',
//                                         // height: { xs: "20px", md: '35px' },
//                                         // width: { xs: "20px", md: '35px' },

//                                         p: { xs: "5px", md: '10px' }

//                                     }}
//                                 >


//                                     <Box
//                                         component="img"
//                                         src={profileImageIcon}
//                                         alt="profile-icon"
//                                         sx={{
//                                             height: { xs: "14px", md: '16px' },
//                                             width: { xs: "14px", md: '16px' },
//                                         }}
//                                     />
//                                 </Box>
//                             )}
//                             <Box sx={{ paddingLeft: { xs: '5px', md: "10px" } }}>
//                                 <Typography variant="body1" sx={{ fontSize: { xs: '12px', md: "14px", color: "white" } }}>
//                                     My Account
//                                 </Typography>

//                                 <Typography variant="body1" sx={{ fontSize: { xs: '10px', md: "12px" }, color: "white" }}>
//                                     {getUserById?.data?.first_name} {getUserById?.data?.last_name}
//                                 </Typography>
//                             </Box>
//                         </Box>


//                         <Menu
//                             anchorEl={anchorEl}
//                             open={Boolean(anchorEl)}
//                             onClose={handleMenuClose}
//                             sx={{ mt: 1 }}
//                         >
//                             {sessioncustomer_id === "null" || sessioncustomer_id === null ? (
//                                 // If sessionCustomerId is null or "null", show login and register options
//                                 <>
//                                     <MenuItem onClick={() => handleNavigation('/login')}>Login</MenuItem>
//                                     <MenuItem onClick={() => handleNavigation('/register')}>Register</MenuItem>
//                                 </>
//                             ) : (
//                                 // If sessionCustomerId is not null, show order history, profile, and logout options
//                                 <>
//                                     <MenuItem onClick={() => handleNavigation('/user/editprofile')}>Edit Profile</MenuItem>

//                                     <MenuItem onClick={() => handleNavigation('/changepassword')}>Change Password</MenuItem>

//                                     <MenuItem onClick={() => handleNavigation('/')}>Logout</MenuItem>

//                                 </>
//                             )}
//                         </Menu>


//                     </Box>

//                     {/* Mobile Menu Icon */}

//                 </Box>
//             </AppBar>


//             <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
//                 <Box sx={{ width: 250, background: "#fff", padding: "20px", height: "100%" }}>
//                     <List>
//                         {navItems.map((item) => (
//                             <Box key={item.label}>
//                                 <ListItemButton
//                                     component={Link}
//                                     to={item.path}
//                                     sx={{

//                                         color: location.pathname === item.path ? "white" : "#252525",
//                                         fontWeight: location.pathname === item.path ? "bold" : "normal",
//                                         background: location.pathname === item.path ? "var(--main-color)" : "transparent",
//                                         borderRadius: "10px",
//                                         transition: "0.3s",
//                                         "&:hover": {
//                                             background: "#f5f5f5",
//                                         },
//                                     }}
//                                     // onClick={() => setSubmenuOpen(submenuOpen === item.label ? null : item.label)}
//                                     onClick={(e) => {
//                                         // e.preventDefault(); // Prevents navigation if needed
//                                         if (item.subLabel) {
//                                             e.preventDefault();
//                                             setSubmenuOpen(submenuOpen === item.label ? null : item.label);
//                                         } else {
//                                             setSubmenuOpen(null); // Handle cases where label is missing
//                                         }
//                                     }}
//                                 >
//                                     <item.icon style={{ color: "white", marginRight: "5px" }} />
//                                     {item.label}
//                                     {item.subLabel && (submenuOpen === item.label ? <ExpandLess /> : <ExpandMore />)}
//                                 </ListItemButton>

//                                 {/* Submenu */}
//                                 {item.subLabel && (
//                                     <Collapse in={submenuOpen === item.label} timeout="auto" unmountOnExit>
//                                         <List component="div" disablePadding>
//                                             {item.subLabel.map((sub) => (
//                                                 <ListItemButton key={sub.subPath} component={Link} to={sub.subPath} sx={{ pl: 4 }}>
//                                                     <ListItemText primary={sub.sublabel} />
//                                                 </ListItemButton>
//                                             ))}
//                                         </List>
//                                     </Collapse>
//                                 )}
//                             </Box>
//                         ))}
//                     </List>
//                 </Box>
//             </Drawer>
//         </>
//     );
// };

// export default CustomUserAppBar;



// --------------------------------------------------------


import React, { useEffect, useRef, useState } from "react";
import {
    AppBar,
    Toolbar,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Box,
    Drawer,
    Grid,
    Collapse,
    TextField,
    Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import "./CustomAppBar.css";
import logo from "../../Assets/WeConnectLogo.png";
import { IoHomeOutline } from "react-icons/io5";
import { GrTableAdd } from "react-icons/gr";
import { FiFilePlus } from "react-icons/fi";
// import { FcAbout } from "react-icons/fc";
import { RiFolderInfoFill } from "react-icons/ri";

// import React, { useState } from "react";
import { Menu, MenuItem, Avatar, Typography, Button, InputAdornment, IconButton, PaperProps, MenuListProps } from "@mui/material";
import { AccountCircle, ExpandLess, ExpandMore } from "@mui/icons-material";
import profileImageIcon from "../../Assets/user_man_image.png"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { MdNotificationsNone } from "react-icons/md";
import { LuMessageSquareText } from "react-icons/lu";
import { MdOutlineWorkOutline } from "react-icons/md";
import { FaUserSecret } from "react-icons/fa6";
import { TbUsersGroup } from "react-icons/tb";
import { useDispatch, useSelector } from 'react-redux'
import actions from "../../ReduxStore/actions";
import { adminUrl } from "../../constants";
import GlobalSearch from "../../Pages/Website/HomeProfile/GlobalSearch";

import SearchIcon from "@mui/icons-material/Search";
import { activateSearch, deactivateSearch } from '../../ReduxStore/Slices/search/searchSlice';

const CustomUserAppBar = ({ dynamicLogo }) => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const location = useLocation()
    const dispatch = useDispatch()
    const sessionUserId = sessionStorage.getItem("userId")

    const { getUserById } = useSelector(state => state?.getUserById);
    const { editUserInfo } = useSelector(state => state?.editUserInfo);



    // const sessionUserId = sessionStorage.getItem("userId")

    // const dispatch = useDispatch()
    useEffect(() => {

        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getUserById/${sessionUserId}`,
            };
            const response = await dispatch(actions.GETUSERBYID(data1));


        }
        fetchData()


    }, [editUserInfo])

    const { getNotificationCategoryCounts } = useSelector(state => state?.getNotificationCategoryCounts);

    console.log(getNotificationCategoryCounts, 'getNotificationCategoryCounts');


    const navItems = [
        {
            label: "Home", path: "/user", icon: IoHomeOutline
        },
        {
            label: "Connect-Friends", path: "/user/connectfriends", icon: TbUsersGroup
        },
        {
            label: "Notifications", path: "/user/notification", icon: MdNotificationsNone
        }, {
            label: "Messages", path: "/user/messages", icon: LuMessageSquareText
        },
        {
            label: "Post", subLabel: [
                {
                    icon: IoHomeOutline,
                    sublabel: "Post Jobs",
                    subPath: "/user/postjobs"
                },
                {
                    icon: IoHomeOutline,
                    sublabel: "Post Internship",
                    subPath: "/user/postinternship"
                },
                // {
                //     icon: IoHomeOutline,
                //     sublabel: "Search Jobs",
                //     subPath: "/user/searchjob"
                // },
                // {
                //     icon: IoHomeOutline,
                //     sublabel: "Serach Internship",
                //     subPath: "/user/searchinternship"
                // },
                // {
                //     icon: IoHomeOutline,
                //     sublabel: "Upload Resume",
                //     subPath: "/user/uploadresume"
                // }
            ], path: "/user/post", icon: MdOutlineWorkOutline
        },
        // {
        //     label: "Reports", subLabel: [
        //         {
        //             icon: IoHomeOutline,
        //             sublabel: "Alumni Registration-Confirmation",
        //             subPath: "/alumni_register_confirmation"
        //         },
        //         {
        //             icon: IoHomeOutline,
        //             sublabel: "Alumni Report-Search By Course",
        //             subPath: "/reportsearch_course"
        //         },
        //         {
        //             icon: IoHomeOutline,
        //             sublabel: "Alumni Report-Search By Name",
        //             subPath: "/reportsearch_name"
        //         }
        //     ], path: "/reports", icon: FiFilePlus
        // },
        {
            label: "About-us", path: "/user/aboutus", icon: RiFolderInfoFill
        },

    ];

    const toggleDrawer = (open) => (event) => {
        if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }
        setDrawerOpen(open);
    };
    const [anchorEl, setAnchorEl] = useState(null);
    const [submenuOpen, setSubmenuOpen] = useState(null);
    const [anchorElMain, setAnchorElMain] = useState(null); // For main menu
    const [anchorElSub, setAnchorElSub] = useState(null); // For submenu
    // const { getUserById } = useSelector(state => state?.getUserById);


    const handleSubMenuOpen = (event, label) => {
        setAnchorElSub(event.currentTarget); // Use a separate state for submenu anchor
        setSubmenuOpen(label);


    };

    const handleSubMenuClose = () => {
        setAnchorElSub(null);
        setSubmenuOpen(null);
        console.log("onnnnnn");
    };


    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const navigate = useNavigate()

    const { markRoomNotificationsAsRead } = useSelector(
        (state) => state?.markRoomNotificationsAsRead
    );

    useEffect(() => {

        console.log("responseresponse out");

        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getNotificationCategoryCounts/${sessionUserId}`,
            };
            const response = await dispatch(actions.GETNOTIFICATIONCATEGORYCOUNTS(data1));


        }
        fetchData()
    }, [markRoomNotificationsAsRead])



    const handleNotificationApiCL = async () => {
        const data1 = {
            data: {},
            method: "get",
            apiName: `getNotificationCategoryCounts/${sessionUserId}`,
        };
        const response = await dispatch(actions.GETNOTIFICATIONCATEGORYCOUNTS(data1));

    }



    const handleNavigation = (path) => {
        console.log(`Navigating to ${path}`);
        navigate(path)
    };

    const handleNavigationLogout = () => {
        console.log("Logging out...");
    };

    const sessionFirstName = "John"; // Replace with actual session data
    const sessioncustomer_id = 12345; // Replace with actual session data
    // const profileImageIcon=""

    const [anchorEll, setAnchorEll] = useState(null);
    const [showSearch, setShowSearch] = useState(false);

    const handleMenuClick = (event) => {
        setAnchorEll(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEll(null);
    };

    const handleSearchClick = () => {
        setShowSearch(true);
        handleClose();
    };


    const [searchTerm, setSearchTerm] = useState("");
    const [anchorEl2, setAnchorEl2] = useState(null); // renamed to anchorEl2
    const [suggestions] = useState(["User", "Post", "Comment", "Tag"]); // Example menu items

    const handleSearch = () => {
        console.log("Searching for:", searchTerm);
        setAnchorEl2(null); // close the menu
        dispatch(deactivateSearch());
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleSearch();
        }
    };

    const handleTextFieldClick = (event) => {
        setAnchorEl2(event.currentTarget); // Open menu
        dispatch(deactivateSearch());
    };

    const handleMenuItemClick = (value) => {
        setSearchTerm(value);
        setAnchorEl2(null);
    };

    const handleClose2 = () => {
        setAnchorEl2(null);
        // dispatch(deactivateSearch());
    };

    const menuStyles = {
        PaperProps: {
            style: {
                maxHeight: 200,  // Set the maxHeight to your desired value
                overflowY: 'auto',  // Enable vertical scroll
            }
        },
        MenuListProps: {
            style: {
                maxHeight: 200,  // Set max height of list inside menu
                overflowY: 'auto',  // Enable scroll on MenuList
            }
        }
    };

    return (
        <>
            {/* Custom Navbar */}
            {/* <AppBar
        // position="fixed"
        sx={{
          background: "#fff",
          boxShadow: "4px 8px 25px rgba(0, 0, 0, 0.1)",
          borderRadius: "50px",
          padding: "10px 20px",
          margin: "10px auto",
          // maxWidth: "85%",
          display: "flex",
          alignItems: "center",
        }}
      > */}
            <AppBar
                position="static"  // Keeps AppBar at the top but allows smooth scrolling behavior
                sx={{
                    background: "var(--main-color)",
                    boxShadow: "4px 8px 25px rgba(0, 0, 0, 0.1)",
                    // borderRadius: "50px",
                    padding: "10px 20px",
                    // margin: "10px auto",
                    // maxWidth: "85%",
                    // display: "flex",
                    // alignItems: "center",
                    // top: 0,  // Ensures it sticks at the top
                    zIndex: 1100,  // Keeps it above other content
                }}
            >

                <Box className="appbar-container" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                    {/* Logo */}
                    <Box className="nav-logo" sx={{ display: { md: 'block', xs: "none" } }}>
                        <Box component="img" src={dynamicLogo} alt="Logo" className="nav-logo-img" sx={{ height: { xs: "40px", md: "50px" }, width: { xs: "110px", md: "200px" } }} />
                    </Box>

                    <IconButton
                        edge="end"
                        sx={{
                            display: { xs: "block", md: "none" },
                            // background: "#f5f5f5",
                            // padding: "8px",
                            // borderRadius: "50%",
                        }}
                        onClick={toggleDrawer(true)}
                    >
                        <MenuIcon sx={{ color: "white", fontSize: "28px" }} />
                    </IconButton>

                    <Box
                        sx={{
                            p: 2,
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <TextField
                            fullWidth
                            sx={{ maxWidth: 400, backgroundColor: "#fff", borderRadius: 1 }}
                            size="small"
                            variant="outlined"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onClick={handleTextFieldClick}
                            onKeyPress={handleKeyPress}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleSearch} edge="end">
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <Menu
                            anchorEl={anchorEl2}
                            open={Boolean(anchorEl2)}
                            onClose={handleClose2}
                            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                            {...menuStyles}
                        >
                            <GlobalSearch />
                        </Menu>
                    </Box>



                    {/* Navigation Menu for Desktop */}

                    <Toolbar sx={{ flexGrow: 1, justifyContent: "end", display: { xs: "none", md: "flex" } }}>
                        <Grid container className="nav-menu" spacing={2} justifyContent="center">
                            {navItems.map((item) => (

                                <Grid item key={item.label}>
                                    <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}>

                                        <ListItemButton
                                            component={Link}
                                            to={item.path || "#"}
                                            sx={{
                                                position: "relative",
                                                // color: "white",
                                                // color: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "red" : "black",

                                                borderRadius: "10px",
                                                // transition: "0.3s",
                                                // "&::after": {
                                                //     content: '""',
                                                //     position: "absolute",
                                                //     // color: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "red" : "black",
                                                //     // left: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "23%" : "50%",
                                                //     bottom: 0,
                                                //     // width: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "60%" : "0%",
                                                //     height: "3px",
                                                //     // borderRadius: "10px",
                                                //     backgroundColor: "white",
                                                //     transition: "width 0.3s ease, left 0.3s ease",
                                                // },
                                                // "&:hover::after": {
                                                //     color: "red"
                                                //     // width: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "60%" : "60%",
                                                //     // left: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "20%" : "20%",
                                                // },
                                            }}
                                            onClick={(e) => {
                                                handleNotificationApiCL()
                                                if (item.subLabel) {
                                                    e.preventDefault();
                                                    handleSubMenuOpen(e, item.label)

                                                    setSubmenuOpen(submenuOpen === item.label ? null : item.label);
                                                } else {
                                                    setSubmenuOpen(null);
                                                }
                                            }}
                                        >
                                            <div style={{ position: "relative", display: "inline-block" }}>
                                                <item.icon style={{
                                                    color: "white",
                                                    // marginRight: "5px",
                                                    fontSize: "20px",
                                                    // color: location.pathname === item.path || item.subLabel?.some(sub => sub.subPath === location.pathname) ? "white" : "white",

                                                }}
                                                />
                                                {"Messages" === item.label || "Notifications" === item.label ? (
                                                    <span
                                                        style={{
                                                            position: "absolute",
                                                            top: "-5px",
                                                            right: "-5px",
                                                            backgroundColor: "red",
                                                            color: "white",
                                                            borderRadius: "50%",
                                                            padding: "2px 6px",
                                                            fontSize: "12px",
                                                            fontWeight: "bold",
                                                            lineHeight: 1,
                                                        }}
                                                    >
                                                        {"Messages" === item.label && getNotificationCategoryCounts?.data[3]?.count}
                                                        {"Notifications" === item.label && getNotificationCategoryCounts?.data[0]?.count}
                                                    </span>) : ""}

                                            </div>
                                            {/* {item.label || "Default Label"} */}
                                            {/* {item.subLabel && <ExpandMoreIcon sx={{ color: "white" }} />} */}
                                        </ListItemButton>




                                    </Box>

                                    {submenuOpen === item.label && (

                                        <Menu
                                            anchorEl={anchorElSub}
                                            open={Boolean(anchorElSub)}
                                            onClose={handleSubMenuClose}
                                            sx={{ mt: 1 }}
                                        >
                                            {item.subLabel.map((sub) => (
                                                <MenuItem key={sub.subPath} component={Link} to={sub.subPath}>
                                                    <Typography variant="subtitle1" sx={{ color: "black" }}>
                                                        {sub.sublabel}

                                                    </Typography>

                                                </MenuItem>
                                            ))}
                                        </Menu>
                                    )}

                                </Grid>
                            ))}
                        </Grid>

                    </Toolbar>

                    {/* <IconButton
                        edge="end"
                        sx={{
                            display: { xs: "block", md: "none" },
                            // background: "#f5f5f5",
                            // padding: "8px",
                            // borderRadius: "50%",
                        }}
                        onClick={toggleDrawer(true)}
                    >
                        <MenuIcon sx={{ color: "#252525", fontSize: "28px" }} />
                    </IconButton> */}
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        {/* <AccountCircleIcon /> */}
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                            }}
                            onClick={handleMenuOpen}
                        >
                            {getUserById?.data?.profileImage ? (
                                <Avatar
                                    src={`${adminUrl}${getUserById?.data?.profileImage}`}
                                    alt="John Doe"
                                    sx={{
                                        width: { md: 40, xs: 30 },
                                        height: { md: 40, xs: 30 },
                                        border: "4px solid white",
                                        // marginTop: "-80px",
                                        // marginLeft: "50px"
                                    }}
                                />
                            ) : (
                                <Box
                                    sx={{
                                        border: '1px solid black',
                                        borderRadius: '50%',
                                        background: 'black',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        // height: { xs: "20px", md: '35px' },
                                        // width: { xs: "20px", md: '35px' },

                                        p: { xs: "5px", md: '10px' }

                                    }}
                                >


                                    <Box
                                        component="img"
                                        src={profileImageIcon}
                                        alt="profile-icon"
                                        sx={{
                                            height: { xs: "14px", md: '16px' },
                                            width: { xs: "14px", md: '16px' },
                                        }}
                                    />
                                </Box>
                            )}
                            <Box sx={{ paddingLeft: { xs: '5px', md: "10px" }, display: { md: "block", xs: "none" } }}>
                                <Typography variant="body1" sx={{ fontSize: { xs: '12px', md: "14px", color: "white" } }}>
                                    My Account
                                </Typography>

                                <Typography variant="body1" sx={{ fontSize: { xs: '10px', md: "12px" }, color: "white" }}>
                                    {getUserById?.data?.first_name} {getUserById?.data?.last_name}
                                </Typography>
                            </Box>
                        </Box>


                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                            sx={{ mt: 1 }}

                        >
                            {sessioncustomer_id === "null" || sessioncustomer_id === null ? (
                                // If sessionCustomerId is null or "null", show login and register options
                                <>
                                    <MenuItem onClick={() => handleNavigation('/login')}>Login</MenuItem>
                                    <MenuItem onClick={() => handleNavigation('/register')}>Register</MenuItem>
                                </>
                            ) : (
                                // If sessionCustomerId is not null, show order history, profile, and logout options
                                <>
                                    <MenuItem sx={{ display: { xs: "block", md: "none" } }}>
                                        <Box sx={{ paddingLeft: { xs: '5px', md: "10px" } }}>
                                            <Typography variant="body1" sx={{ fontSize: { xs: '12px', md: "14px", color: "black" } }}>
                                                My Account
                                            </Typography>

                                            <Typography variant="body1" sx={{ fontSize: { xs: '10px', md: "12px" }, color: "black" }}>
                                                {getUserById?.data?.first_name} {getUserById?.data?.last_name}
                                            </Typography>

                                        </Box>
                                    </MenuItem>
                                    <Divider sx={{ display: { xs: "block", md: "none" } }} />

                                    <MenuItem onClick={() => handleNavigation('/user/editprofile')}>Edit Profile</MenuItem>

                                    <MenuItem onClick={() => handleNavigation('/changepassword')}>Change Password</MenuItem>

                                    <MenuItem onClick={() => handleNavigation('/')}>Logout</MenuItem>

                                </>
                            )}
                        </Menu>


                    </Box>

                    {/* Mobile Menu Icon */}

                </Box>
            </AppBar >


            <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
                <Box sx={{ width: 250, background: "#fff", padding: "20px", height: "100%" }}>
                    <List>
                        {navItems.map((item) => (
                            <Box key={item.label}>
                                <ListItemButton
                                    component={Link}
                                    to={item.path}
                                    sx={{

                                        color: location.pathname === item.path ? "white" : "#252525",
                                        fontWeight: location.pathname === item.path ? "bold" : "normal",
                                        background: location.pathname === item.path ? "var(--main-color)" : "transparent",
                                        borderRadius: "10px",
                                        transition: "0.3s",
                                        "&:hover": {
                                            background: "#f5f5f5",
                                        },
                                    }}
                                    // onClick={() => setSubmenuOpen(submenuOpen === item.label ? null : item.label)}
                                    onClick={(e) => {
                                        // e.preventDefault(); // Prevents navigation if needed
                                        console.log("this");

                                        if (item.subLabel) {
                                            e.preventDefault();
                                            setSubmenuOpen(submenuOpen === item.label ? null : item.label);
                                        } else {
                                            setSubmenuOpen(null); // Handle cases where label is missing
                                        }
                                    }}
                                >
                                    <item.icon style={{ color: location.pathname === item.path ? "white" : "black", marginRight: "5px" }} />
                                    {item.label}
                                    {item.subLabel && (submenuOpen === item.label ? <ExpandLess /> : <ExpandMore />)}
                                </ListItemButton>

                                {/* Submenu */}
                                {item.subLabel && (
                                    <Collapse in={submenuOpen === item.label} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            {item.subLabel.map((sub) => (
                                                <ListItemButton key={sub.subPath} component={Link} to={sub.subPath} sx={{ pl: 4 }}>
                                                    <ListItemText primary={<Typography variant="subtitle1">{sub.sublabel}</Typography>} />
                                                </ListItemButton>
                                            ))}
                                        </List>
                                    </Collapse>
                                )}
                            </Box>
                        ))}
                    </List>
                </Box>
            </Drawer>
        </>
    );
};

export default CustomUserAppBar;
